<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'withholdingAdd',
    components: {
      baseEdit,
    },
  };
</script>
